import {APIStatusType} from '@web/core/constants'

export const ProductType = {
    RENTAL: 'RENTAL',
    OVERSEA: 'OVERSEA',
    RESERVATION: 'RESERVATION',
} as const
export type ProductTypeType = Constant<typeof ProductType>

export const DeliveryFee = {
    FREE: 'FREE',
    AFTER_PAY: 'AFTER_PAY',
    PRE_PAY: 'PRE_PAY',
} as const
export type DeliveryFeeType = Constant<typeof DeliveryFee>

export const DeliveryTooltipType = {
    BRANCH: 'BRANCH',
    KURLY: 'KURLY',
} as const
export type DeliveryTooltipTypeType = Constant<typeof DeliveryTooltipType>

export interface AiTEMSTab {
    /** 더보기 랜딩 정보 */
    landingKey: string
    /** 제목 정보 */
    title: {
        /** @example '함께 구매할 만한 %s는 어떠세요?' */
        template: string
        /** @example ['스커트'] */
        highlight: string[]
    }
    products: {
        /** 상품명 */
        name: string
        /** 상품 타입 */
        type?: ProductTypeType
        /** 썸네일 */
        imageUrl: string
        /** PC 상품 URL */
        pcUrl: string
        /** MO 상품 URL */
        moUrl?: string
        /** 배송비 제외 가격 */
        price: number
        /** 할인율 */
        discountRatio?: number
        /** 렌탈 정보 */
        rental?: {
            /** 총 렌탈료 */
            totalFee: number
            /** 계약기간(월) */
            contractPeriod: number
        }
        /** 배송 정보 */
        delivery: {
            /** 배송비 지불방식 */
            feeType?: DeliveryFeeType
            /** 배송비 */
            fee?: number
            /** N배송 정보 */
            fastDelivery: boolean
            tooltipType?: 'BRANCH' | 'KURLY'
        }
        /** 설치 유무 */
        installation: boolean
        logData: {
            saleTp: string
            /** 카테고리ID */
            catId: string
            /** 몰 Seq */
            mallNo: string
            /** 몰Seq + 채널Seq */
            mallChnlSeq: string
            /** 채널Seq */
            chnlSeq?: string
            /** 검색 상품 ID */
            nvMid: string
            /** 상품명 */
            name: string
            /** mall의 상품 ID */
            mallProductId: string
            /** 배송비 제외 가격 */
            price: number
            /** PC 상품 URL */
            pcUrl: string
            /** nlog 로깅 필수, AiTEMS 지표 분석에 활용 */
            recInfo: object
        }
    }[]
}

export const AdStatus = {
    IDLE: 'IDLE',
    LOAD: 'LOAD',
    ERROR: 'ERROR',
} as const

export type AdStatusType = Constant<typeof AdStatus>

export interface AiTEMSState {
    fetchStatus: APIStatusType
    adStatus: AdStatusType
    tabs: AiTEMSTab[]
    page: number
    products: Array<{ecNvMid: string}>
}

export type RootState = {aitems: AiTEMSState}
